import { Carousel } from '../../components/Carousel';
import { ItemCard } from '../../components/ItemCard';
import { RecommendationsWrapper } from './Recommendations.styles';
import type { RecommendationsProps } from './Recommendations.types';

export function Recommendations({
  items,
  onSelect,
  title = 'You might also like',
  fromPriceLabel = 'From',
  noImageLabel = 'No image',
}: RecommendationsProps) {
  if (items.length === 0) return null;

  return (
    <RecommendationsWrapper>
      <Carousel title={title} visibleCount={{ mobile: 1.2, desktop: 2 }} showProgress>
        {items.map((item) => (
          <ItemCard
            key={item.id}
            image={{ src: item.imageUrl, alt: item.name, placeholderLabel: noImageLabel }}
            title={item.name}
            meta={item.meta}
            price={
              item.price
                ? {
                    amount: item.price.amount,
                    currencyCode: item.price.currencyCode,
                    label: fromPriceLabel,
                    discount: item.discount,
                  }
                : undefined
            }
            ariaLabel={item.name}
            onSelect={onSelect ? () => onSelect(item.id) : undefined}
          />
        ))}
      </Carousel>
    </RecommendationsWrapper>
  );
}
